import { proxy } from 'valtio';

const discountState = proxy({
  dirtyFormExists: false,
});

export default discountState;
